// frontend/src/components/dashboards/VendorDashboard.js
import React, { useState, useEffect } from "react";
import API from "../../../api";
import "./vendor.css";
import CartModal from "./CartModal";
import CheckoutModal from "./CheckoutModal";
import logo from "../../../assets/logo.png";
import SubCategorySlider from "./SubCategorySlider";
import MarketplaceProductCard from "./MarketplaceProductCard";
import {
  MapPin,
  Navigation,
  MapPinned,
  Search,
  X
} from "lucide-react";
import LocationPicker from "../../common/LocationPicker";


function VendorDashboard() {
  const CATEGORIES = [
    { id: "raw", label: "Raw Materials" },
    { id: "furniture", label: "Furniture" },
    { id: "electrical", label: "Electrical" },
    { id: "plumbing", label: "Plumbing" },
    { id: "concrete", label: "Ready-Mix Concrete" },
    { id: "rental", label: "Rental Equipment" },
  ];

  const [selectedLocation, setSelectedLocation] = useState("All India");
const [manualLocation, setManualLocation] = useState("");
const [showLocationModal, setShowLocationModal] = useState(false);
  
  const [projectLocation, setProjectLocation] = useState({
  address: "",
  city: "",
  district: "",
  state: "",
  pincode: "",
  country: "India",

  latitude: null,
  longitude: null,

  geo: {
    type: "Point",
    coordinates: []
  }
});
const [showMapPicker, setShowMapPicker] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState("raw");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedCity, setSelectedCity] = useState("All Cities");
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState({});

  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [showAddedMsg, setShowAddedMsg] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  const loggedInUser = JSON.parse(
  localStorage.getItem("civilink_user") || "{}"
);

const [checkoutData, setCheckoutData] = useState({
  name: loggedInUser.name || "",
  email: loggedInUser.email || "",
  phone: "",
  deliveryLocation: null,
});
 // My Orders (Customer)
const [showMyOrders, setShowMyOrders] = useState(false);
const [customerOrders, setCustomerOrders] = useState([]);


   const getCurrentLocation = () => {
  if (!navigator.geolocation) {
    alert("Geolocation is not supported.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;

      // Later you can reverse geocode these coordinates
      

      setSelectedLocation("Current Location");
    },
    () => {
      alert("Unable to fetch location.");
    }
  );
};




  const fetchProducts = async () => {
  try {
    let url = "/api/admin/products/all";

    if (
      projectLocation.latitude &&
      projectLocation.longitude
    ) {
      url += `?lat=${projectLocation.latitude}&lng=${projectLocation.longitude}`;
    }

    const res = await API.get(url);

    setProducts(res.data);
    
  } catch (err) {
    console.error("Error loading products", err);
  }
};
  useEffect(() => {
  fetchProducts();
}, [projectLocation]);

    // Load cart from localStorage when page opens
  useEffect(() => {
  const savedCart = localStorage.getItem("vendorCart");
  if (savedCart) {
    setCart(JSON.parse(savedCart));
  }
  }, []);
 
  // Save cart to localStorage whenever it changes
  useEffect(() => {
  localStorage.setItem("vendorCart", JSON.stringify(cart));
  }, [cart]);


  const filteredProducts = products.filter((p) => {
  return (
    p.category === selectedCategory &&
    (selectedSubCategory === "" ||
      p.subCategory === selectedSubCategory) &&
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
});


  const submitOrder = async () => {
  try {
   if (
  !checkoutData.name ||
  !checkoutData.phone ||
  !checkoutData.deliveryLocation?.address
) {
  alert("Please enter your mobile number and select your delivery location.");
  return;
}

    if (cart.length === 0) {
      alert("Cart is empty");
      return;
    }

    // 🔑 assume all items belong to same vendor
    const vendorId = cart[0]?.vendorId;

    if (!vendorId) {
  alert("Vendor ID missing. Please refresh and try again.");
  return;
}

   const total = cart.reduce((sum, item) => {
  if (item.productType === "RENTAL") {
    const daily = Number(item.dailyPrice) || 0;
    const qty = Number(item.quantity) || 1;
    const days = Number(item.days) || 1;
    return sum + daily * qty * days;
  }

  const price = Number(item.price) || 0;
  const qty = Number(item.quantity) || 1;
  return sum + price * qty;
}, 0);


    const res = await API.post(
  "/order",
      {
        customer: {
  name: checkoutData.name,
  phone: checkoutData.phone,
  email: checkoutData.email,

  deliveryLocation: {
    address: checkoutData.deliveryLocation.address,
    city: checkoutData.deliveryLocation.city,
    district: checkoutData.deliveryLocation.district,
    state: checkoutData.deliveryLocation.state,
    pincode: checkoutData.deliveryLocation.pincode,
    country: checkoutData.deliveryLocation.country,
    latitude: checkoutData.deliveryLocation.latitude,
    longitude: checkoutData.deliveryLocation.longitude,
  },
},
        cart: cart.map(item => ({
  productId: item._id,                 // internal
  vendorProductCode: item.vendorProductCode, // business ID
  name: item.name,
  productType: item.productType,
  price: item.productType === "SALE" ? item.price : undefined,
dailyPrice: item.productType === "RENTAL" ? item.dailyPrice : undefined,

  quantity: item.quantity,
  days:
    item.productType === "RENTAL"
      ? item.days
      : undefined
})),
        total,

          vendorId: vendorId, 
      
        
      }
    );

    if (!res.data.success) {
      alert("Order failed. Try again.");
      return;
    }

    // ✅ Open WhatsApp if backend sent link
    if (res.data.whatsappLink) {
      window.open(res.data.whatsappLink, "_blank");
    }

    alert("Order placed successfully");

    localStorage.setItem("customerPhone", checkoutData.phone);

    // ✅ Cleanup
    setCart([]);
    localStorage.removeItem("vendorCart");
    setShowCheckout(false);

  } catch (err) {
    console.error("Order submit error:", err);
    alert("Server error while placing order");
  }
};

const loadMyOrders = async () => {
  try {
    const res = await API.get("/customer/orders/my");

    setCustomerOrders(res.data.orders);
  } catch (err) {
    console.error("Load my orders failed", err);
  }
};



  return (
    <div className="vendor-page">
      {/* Top Bar */}
      <header className="vendor-header">
        <div className="vendor-left">
  <button
    className="vendor-menu-btn"
    onClick={() => setShowMenu(!showMenu)}
  >
    ☰
  </button>
  <div className="vendor-logo">
  <img src={logo} alt="Civilink" />
</div>

</div>


        <div className="vendor-search">
          <input
            type="text"
            placeholder="Search materials, vendors…"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="vendor-actions">
          <button
    className="vendor-location-pill"
    onClick={() => setShowLocationModal(true)}
>
    <MapPin size={18} />

    <span>
        {selectedLocation === "All India"
            ? "Select Location"
            : selectedLocation}
    </span>
</button>
          <button
           className="vendor-cart-btn"
          onClick={() => setShowCart(true)}
>
           🛒
         {cart.length > 0 && (
            <span className="vendor-cart-badge">
         {cart.length}
        </span>
       )}

       </button>


        </div>
      </header>
      {showMenu && (
  <div className="vendor-menu">
    <button
      className="vendor-menu-item"
      onClick={() => {
        window.location.href = "/admin";
      }}
    >
      Admin Panel
    </button>

    <button
     className="vendor-menu-item"
     onClick={() => {
    setShowContact(true);
    setShowMenu(false);
      }}
    >
     Contact
    </button>

    <button
  className="vendor-menu-item"
  onClick={() => {
    window.location.href = "/my-orders";
  }}
>
  My Orders
</button>



  </div>
)}

      {/* Category Strip */}
      <div className="vendor-categories">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            className={
              cat.id === selectedCategory
                ? "vendor-category active"
                : "vendor-category"
            }
            onClick={() => {
    setSelectedCategory(cat.id);
    setSelectedSubCategory("");
}}
          >
            {cat.label}
          </button>
        ))}
      </div>

     <SubCategorySlider
  products={products}
  selectedCategory={selectedCategory}
  selectedSubCategory={selectedSubCategory}
  setSelectedSubCategory={setSelectedSubCategory}
/>

{showLocationModal && (

<div className="vendor-modal-overlay">

<div className="location-modal">

<div className="location-header">

<h3>Choose Location</h3>

<button
onClick={() => setShowLocationModal(false)}
>
<X size={18}/>
</button>

</div>

<button
className="location-option"
onClick={()=>{
getCurrentLocation();
setShowLocationModal(false);
}}
>

<Navigation size={18}/>

<div>

<strong>Use Current Location</strong>

<p>Find nearby vendors automatically</p>

</div>

</button>

<button
  className="location-option"
  onClick={() => {
    setShowLocationModal(false);
    setShowMapPicker(true);
  }}
>
  <MapPinned size={18} />

  <div>
    <strong>Choose Project Location</strong>
    <p>Select your construction site on the map</p>
  </div>
</button>

<div className="location-search">

<Search size={18}/>

<input
placeholder="Search city or pincode"
value={manualLocation}
onChange={(e)=>{

setManualLocation(e.target.value);
setSelectedLocation(e.target.value);

}}
/>

</div>





</div>

</div>

)}

      {showContact && (
  <div className="vendor-modal-overlay">
    <div className="vendor-modal">
      <div className="vendor-modal-header">
        <h3>Contact Admin</h3>
        <button
          className="vendor-modal-close"
          onClick={() => setShowContact(false)}
        >
          ✕
        </button>
      </div>

      <div className="vendor-modal-body">
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:civilink.official@gmail.com">
            civilink.official@gmail.com
          </a>
        </p>
        <p>
          <strong>whatsApp:</strong>{" "}
          <a href="https://wa.me/919344425095?text=Hi%20I%20found%20this%20on%20Civilink"
      target="_blank"
      rel="noopener noreferrer"
          
          >+91 9344425095</a>
        </p>
        <p className="vendor-modal-note">
          Our admin team will guide you with construction materials,
          vendors, and pricing.
        </p>
      </div>
    </div>
  </div>
)}


      {/* Info Banner */}
      <section className="vendor-banner">
        <h2>
          {selectedCategory === "raw" && "Raw Materials for Your Site"}
          {selectedCategory === "furniture" &&
            "Construction-Grade Furniture"}
          {selectedCategory === "electrical" &&
            "Safe & Reliable Electrical Materials"}
          {selectedCategory === "plumbing" &&
            "Plumbing Pipes & Fittings"}
          {selectedCategory === "concrete" && "Ready-Mix Concrete Supply"}
          {selectedCategory === "rental" &&
            "Rental Shuttering & Equipment"}
        </h2>
        <p>
          Showing best options{" "}
          {selectedLocation === "All India"
            ? "across all locations."
            : `available in ${selectedCity}.`}
        </p>
      </section>

      <main className="vendor-products">
  {filteredProducts.length === 0 ? (
    <div className="vendor-empty">
      No products found for this filter. Try another city or search term.
    </div>
  ) : (
    filteredProducts.map((p) => (
      <MarketplaceProductCard
        key={p._id}
        product={p}
        cart={cart}
        setCart={setCart}
        selectedVariants={selectedVariants}
        setSelectedVariants={setSelectedVariants}
        setShowAddedMsg={setShowAddedMsg}
        setSelectedProduct={setSelectedProduct}
      />
    ))
  )}
</main>

    {selectedProduct && (
  <div className="vendor-modal-overlay">
    <div className="vendor-modal">
      <div className="vendor-modal-header">
        <h3>{selectedProduct.name}</h3>
        <button
          className="vendor-modal-close"
          onClick={() => setSelectedProduct(null)}
        >
          ✕
        </button>
      </div>

      <div className="vendor-modal-body">
        {selectedProduct.imageUrl && (
          <img
            src={selectedProduct.imageUrl}
            alt={selectedProduct.name}
            className="vendor-product-image"
          />
        )}

        <p>
  <strong>Price:</strong>{" "}
  {selectedProduct.productType === "SALE" ? (
    selectedProduct.variants?.length ? (
      <>From ₹{Math.min(...selectedProduct.variants.map(v => v.price))}</>
    ) : (
      <>₹{selectedProduct.price}</>
    )
  ) : (
    <>From ₹{Math.min(...selectedProduct.variants.map(v => v.dailyPrice))} / day</>
  )}
</p>


        <p>
          <strong>Category:</strong>{" "}
          {selectedProduct.category}
        </p>

        <p>
          <strong>Vendor:</strong>{" "}
          {selectedProduct.vendor?.name}
        </p>

        <p>
          <strong>City:</strong> {selectedProduct.city}
        </p>

        <p className="vendor-modal-note">
          For bulk orders or negotiation, please contact admin.
        </p>
      </div>
    </div>
  </div>
)}  

 

  
  
  {showAddedMsg && (
    <div className="vendor-toast">
      ✅ Item added to cart
    </div>
  )}

{showCart && (
  <CartModal
    cart={cart}
    setCart={setCart}
    onClose={() => setShowCart(false)}
    onCheckout={() => {
      setShowCart(false);
      setShowCheckout(true);
    }}
  />
)}

{/* ✅ CHECKOUT MODAL */}
{showCheckout && (
  <CheckoutModal
    cart={cart}
    checkoutData={checkoutData}
    setCheckoutData={setCheckoutData}
    onBack={() => {
      setShowCheckout(false);
      setShowCart(true); // ✅ go back to cart
    }}
    onSubmit={submitOrder}  
  />

  )}

 {showMyOrders && (
  <section className="vendor-orders">
    <h3>My Orders</h3>

    {customerOrders.length === 0 ? (
      <p>No orders yet.</p>
    ) : (
      <table className="vendor-orders-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Customer</th>
            <th>Items</th>
            <th>Total</th>
            <th>Status</th>
            <th>Invoice</th>
          </tr>
        </thead>

        <tbody>
          {customerOrders.map(order => (
            <tr key={order._id}>
              <td>
                {new Date(order.createdAt).toLocaleString()}
              </td>

              <td>
                <strong>{order.customer.name}</strong>
              </td>

              <td>
                {order.items.map((i, idx) => (
                  <div key={idx}>
                    {i.name} × {i.quantity}
                  </div>
                ))}
              </td>

              <td>₹{order.total}</td>

              <td>{order.status || "Placed"}</td>

              <td>
                {order.invoiceUrl ? (
                  <a
                    href={order.invoiceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </section>
)}

<LocationPicker
  open={showMapPicker}
  onClose={() => setShowMapPicker(false)}
  initialLocation={
  projectLocation.latitude
    ? projectLocation
    : null
}
  onSelect={(location) => {
    setProjectLocation(location);

    setSelectedLocation(location.city || location.address);

    setShowMapPicker(false);

    
  }}
/>

 
    </div>
  );
}


export default VendorDashboard;
